import moment from "moment";

export const types = {
  FREE: "Gratis",
  GUARANTEED: "Garantizado",
  CONDITIONED: "Condicionado",
}

const reversedTypes = Object.entries(types).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

const formatDate = (date, format) => moment(date).format(format);

export class TournamentRow {
  constructor({
    _id,
    name,
    game,
    logo,
    winningAmount,
    type,
    rounds,
    minBet = 0,
    maxPlayers = 0,
    hasMaxPlayers = false,
    playerRetry = false,
    playerInitialPoints = 2000,
    ticketPrice = 0,
    playerType = '',
    start_date = ""
  }) {
    this.id = _id;
    this.name = name;
    this.game = game;
    this.logo = logo;
    this.winningAmount = winningAmount;
    this.rounds = rounds;

    this.minBet = minBet;
    this.maxPlayers = maxPlayers;
    this.hasMaxPlayers = hasMaxPlayers;
    this.playerRetry = playerRetry;
    this.playerInitialPoints = playerInitialPoints;
    this.ticketPrice = ticketPrice;
    this.playerType = playerType;

    this.type = types[type];
    this.start_date = formatDate(start_date, 'YYYY-MM-DD HH:mm:ss');
  }
}

export class TournamentEdit {
  constructor({
    id,
    name,
    game,
    logo,
    winningAmount,
    type,
    rounds,
    minBet = 0,
    maxPlayers = 0,
    hasMaxPlayers = false,
    playerRetry = false,
    playerInitialPoints = 2000,
    ticketPrice = 0,
    playerType = '',
    start_date = ""
  }) {
    this.id = id;
    this.name = name;
    this.game = game;
    this.logo = logo;
    this.winningAmount = winningAmount;
    this.rounds = rounds;

    this.minBet = minBet;
    this.maxPlayers = maxPlayers;
    this.hasMaxPlayers = hasMaxPlayers;
    this.playerRetry = playerRetry;
    this.playerInitialPoints = playerInitialPoints;
    this.ticketPrice = ticketPrice;
    this.playerType = playerType;

    this.date = formatDate(start_date, 'YYYY-MM-DD');
    this.hour = formatDate(start_date, 'HH:mm');

    this.type = reversedTypes[type];
    this.start_date = formatDate(start_date, 'YYYY-MM-DD HH:mm:ss');
  }
}